import $ from "jquery"
import './../scss/style.scss';

//  import Bootstrap 
require('bootstrap');


import { WCAG } from "rytm-wcag";
import { affixFafix } from './shared/affix-fafix'
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { initScrollTo } from './shared/scrollTo'
import { initVideoModal } from './shared/videoModal'
import { loadingSequence } from "./loading";


$(() => {
  // # on ready
  affixFafix()
  initCommon()
  initCookies()
  initScrollTo()
  initVideoModal()
  WCAG.init()
  // loading sequence
  loadingSequence()
});


$(window).on( "load", ()=> {
  // # on load
});